export default {
  setLocale(state, locale) {
    state.lang = locale;
    window.localStorage.setItem('lang', locale);
  },
};
